// extracted by mini-css-extract-plugin
export default {"wrapper":"FormSectionTitle_wrapper__HMQav","first":"FormSectionTitle_first__RME5W"};